import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LANGUAGE, DEFAULT_NS, FALLBACK_LANGUAGE } from './config';
import { NAMESPACES, resources } from './resources';

/**
 * Synchronous init — all resources are bundled (no async backend), so `t()` is
 * ready before the first render. Import this module once, before <App/>.
 */
void i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_LANGUAGE,
  fallbackLng: FALLBACK_LANGUAGE,
  defaultNS: DEFAULT_NS,
  ns: NAMESPACES,
  interpolation: {
    // React already escapes output — double-escaping would corrupt Turkish text.
    escapeValue: false,
  },
  returnNull: false,
});

export default i18n;
